module.exports = __webpack_public_path__ + "img/2-2-4.c0a1c0a5.png";